import { makeAutoObservable, runInAction } from "mobx";
import api from "../../api";
import { Scene } from "./Media";

/**
 * @deprecated This store is deprecated and will be removed.
 * Please use the `useGetShortsGenerationContentScenesQuery` hook from `randmar-api-client` instead.
 *
 * @example
 * // To migrate away from this store in your component:
 * import { useMemo } from "react";
 * import { useGetShortsGenerationContentScenesQuery } from "randmar-api-client";
 * import { Scene } from "../../stores/media/Media"; // Adjust path as needed
 *
 * const { data: scenesInfo, isLoading, isError } = useGetShortsGenerationContentScenesQuery();
 *
 * // The `scenes` property of the store can be replaced with a memoized
 * // transformation of the data from the RTK Query hook. This store converts
 * // the raw API data into `Scene` class instances. To replicate that, you can
 * // use the `Scene.convertFrom` static method.
 * const scenes = useMemo(() => scenesInfo?.map(Scene.convertFrom), [scenesInfo]);
 *
 * // `isLoading` and `isError` can be used to show loading and error states,
 * // replacing the store's `isLoading` and `error` properties.
 */
class MediaStore {
  scenes?: Scene[] = undefined;
  isLoading = false;
  error: string | null = null;

  constructor() {
    makeAutoObservable(this);
    console.warn(
      "Deprecation Warning: The legacy 'MediaStore' is in use. Please migrate to RTK Query as outlined in CONTRIBUTING.md. See the JSDoc in this file for a migration example using `useGetShortsGenerationContentScenesQuery`."
    );
  }

  public async getAllScenes() {
    this.isLoading = true;
    this.error = null;
    try {
      const scenes = await api.media.retrieveAllScenes();
      runInAction(() => {
        this.scenes = scenes.map(Scene.convertFrom);
      });
    } catch (e) {
      runInAction(() => {
        this.error = e instanceof Error ? e.message : String(e);
      });
      console.error(e);
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }
}

export default MediaStore;
